export enum WorkflowRoles {
    ROLE_WORKFLOW_IMPORT_SHOW = 'ROLE_WORKFLOW_IMPORT_SHOW',
    ROLE_WORKFLOW_IMPORT_EDIT = 'ROLE_WORKFLOW_IMPORT_EDIT',
    ROLE_WORKFLOW_EXPORT_SHOW = 'ROLE_WORKFLOW_EXPORT_SHOW',
    ROLE_WORKFLOW_EXPORT_EDIT = 'ROLE_WORKFLOW_EXPORT_EDIT',
}
